// @flow
import React from "react";
import {connect} from "react-redux";
import OriginTerminalSelection from "./TerminalSelection/OriginTerminalSelection";
import FreeSelection from "./FreeSelection/FreeSelection";
import OriginAddressSearch from "./FreeSelection/AddressSearch/OriginAddressSearch";
import DestAddressSearch from "./FreeSelection/AddressSearch/DestAddressSearch";
import Screens from "../../../Store/Views/screens";
import DestTerminalSelection from "./TerminalSelection/DestTerminalSelection";


const RideRequest = props => {
    if (props.showSelectTerminalOrigin) {
        return <OriginTerminalSelection/>;
    }
    if (props.showSelectTerminalDest) {
        return <DestTerminalSelection/>;
    }
    if (props.showOriginSearch) {
        return <OriginAddressSearch/>;
    }
    if (props.showDestSearch) {
        return <DestAddressSearch/>;
    }
    return <FreeSelection/>;

};

const mapStateToProps = state => {
    return {
        showSelectTerminalOrigin: Screens.shouldShowSelectTerminalOrigin(state),
        showSelectTerminalDest: Screens.shouldShowSelectTerminalDest(state),
        showSelectFreeDest: Screens.shouldShowSelectFreeDest(state),
        showOriginSearch: Screens.shouldShowSearchOrigin(state),
        showDestSearch: Screens.shouldShowSearchDest(state),
    };
};

export default connect(mapStateToProps)(RideRequest);


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/RideRequest.js